import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createData } from "../../utility/managerApi";
import Checkbox from "@mui/material/Checkbox";

function NotificationCheckbox({ notificationId, initiallyChecked }) {
  const queryClient = useQueryClient();
  let checkedStatus = Number(initiallyChecked?.read) === 1 ? true : false;
  const [checked, setChecked] = useState(checkedStatus || false);
  const itemId = notificationId?.notificationId || notificationId;

  const mutation = useMutation({
    mutationFn: (id) => createData(`notifications/read/${id}`, "", true),

    retry: false,
  });

  // Handle checkbox state change
  const handleChange = (event) => {
    if (!checked && event.target.checked) {
      setChecked(true);
    }
    mutation.mutate(itemId);
  };

  return (
    <Tooltip title="Mark as read" arrow sx={{ zIndex: 9999 }} placement="top">
      <Checkbox checked={checked} onChange={handleChange} />
    </Tooltip>
  );
}

export default NotificationCheckbox;
